const CLIENT_BASE_URL =
  import.meta.env.VITE_REACT_APP_BASE_CLIENT_URL || 'https://kip.audio';

export function buildDemoOutreachMessage({ candidate, demoResult }) {
  const artistName =
    candidate?.artist_name || demoResult?.artist_name || 'there';
  const trackTitle = candidate?.track_title || demoResult?.track_title;
  const setTitle = candidate?.set_title;
  const setPermalink = demoResult?.set_permalink;
  const shareUrl = candidate?.share_url || demoResult?.share_url;
  const setUrl = setPermalink
    ? `${CLIENT_BASE_URL}/sets/${setPermalink}`
    : null;

  const lines = [
    `Hey ${artistName},`,
    '',
    "I'm reaching out from KIP — we built a demo so you can see how your music shows up when fans use the app.",
  ];

  if (trackTitle && setTitle) {
    lines.push(
      '',
      `We used your track "${trackTitle}" from the set "${setTitle}".`
    );
  } else if (trackTitle) {
    lines.push('', `We used your track "${trackTitle}".`);
  }

  if (setUrl) {
    lines.push('', `Set on KIP: ${setUrl}`);
  }

  if (shareUrl) {
    lines.push('', `Artist preview link: ${shareUrl}`);
  }

  if (demoResult?.login && demoResult?.password) {
    lines.push(
      '',
      'Demo fan account (log in at kip.audio):',
      `  Email: ${demoResult.login}`,
      `  Password: ${demoResult.password}`
    );
    if (demoResult.dry_run) {
      lines.push('', '(Dry run — credentials were not saved.)');
    }
  } else if (candidate?.status === 'demo_created') {
    lines.push(
      '',
      'A demo account already exists. Use "Create / refresh demo" to generate new login credentials.'
    );
  }

  lines.push(
    '',
    'Happy to hear what you think — especially whether the ID workflow feels useful for your sets.',
    '',
    '— KIP team'
  );

  return lines.join('\n');
}
